import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ConfirmationModalComponent} from './confirmation-modal/confirmation-modal.component';
import {UpdateMileageComponent} from './update-mileage/update-mileage.component';
import {TrackingModule} from '@ox/data';
import {TranslateModule} from '@ox/translate';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {GeneralModalModule, TextInputModule} from '@ox/ui';
import {VehicleSnapshotComponent} from './vehicle-snapshot.component';
import {AddMileageComponent} from './add-mileage/add-mileage.component';



@NgModule({
  declarations: [UpdateMileageComponent, ConfirmationModalComponent, VehicleSnapshotComponent, AddMileageComponent],
  imports: [
    CommonModule,
    TrackingModule,
    TranslateModule,
    FormsModule,
    TextInputModule,
    ReactiveFormsModule,
    GeneralModalModule
  ],
  exports: [UpdateMileageComponent, ConfirmationModalComponent, VehicleSnapshotComponent]
})
export class VehicleSnapshotModule {}
